import { Link, Navigate, useParams } from "react-router-dom";
import ManualFrame from "../../components/manuals/ManualFrame";
import { getTopic, relatedTopics } from "../../manuals";
import { appUrl } from "../../config";

export default function ManualTopic({ role, pack }) {
  const { slug } = useParams();
  const topic = getTopic(role, slug);
  if (!topic) return <Navigate to={`/manuals/${role}`} replace />;
  const related = relatedTopics(role, topic.related);

  return (
    <ManualFrame role={role} tree={pack.tree} meta={pack.meta} activeSlug={topic.slug}>
      <article className="manual-article">
        <p className="manual-crumb">
          <Link to={`/manuals/${role}`}>{pack.meta.title}</Link>
        </p>
        <h1>{topic.title}</h1>
        <p className="lead">{topic.forYou}</p>

        <section>
          <h2>How the Process Works</h2>
          {topic.how.length > 1 ? (
            <ol className="manual-steps">
              {topic.how.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          ) : (
            <p>{topic.how[0]}</p>
          )}
        </section>

        <section>
          <h2>{pack.meta.whyHeading}</h2>
          <p>{topic.why}</p>
        </section>

        {topic.examples.length ? (
          <section>
            <h2>Examples</h2>
            {topic.examples.map((item) => (
              <p key={item} className="manual-example">
                {item}
              </p>
            ))}
          </section>
        ) : null}

        {topic.tips.length ? (
          <section>
            <h2>Gentle tips</h2>
            <ul className="manual-tips">
              {topic.tips.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        ) : null}

        {related.length ? (
          <section>
            <h2>Related topics</h2>
            <ul className="manual-related">
              {related.map((item) => (
                <li key={item.slug}>
                  <Link to={`/manuals/${role}/${item.slug}`}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </section>
        ) : null}

        {topic.href ? (
          <p className="manual-open">
            <a className="btn" href={appUrl(topic.href)}>
              Open this in REChecklist
            </a>
          </p>
        ) : null}
      </article>
    </ManualFrame>
  );
}
